import Masterbrian99Button from "../containers/Masterbrian99Button/Masterbrian99Button";

export const routeURL = [
  {
    path: "/yellow-button",
    component: Masterbrian99Button,
  },
];
